import JsTabs from 'js-tabs';
import { tns } from 'tiny-slider/src/tiny-slider';
import Longclick from "ws-longclick/src/longclick";

// import 'tabs-slider/src/scss/tabs.scss';

export default (function () {

  document.addEventListener('DOMContentLoaded', function () {

    const hasRightSidebar = document.querySelector('.page_copy.has-right-sidebar');
    if (hasRightSidebar) {

      let tabScrollContainer = document.querySelector('.super_tabs .js-tabs__tns .js-tabs__tabs-container');
      let buttonNext = document.querySelector('[data-tab-scroller="next"]');
      let buttonPrev = document.querySelector('[data-tab-scroller="prev"]');

      new Longclick({
        target: buttonNext,
        mouseDown() {
          tabScrollContainer.scroll({
            behavior: "smooth",
            left: tabScrollContainer.scrollLeft += 100
          });
        }
      });

      new Longclick({
        target: buttonPrev,
        mouseDown() {
          tabScrollContainer.scroll({
            behavior: "smooth",
            left: tabScrollContainer.scrollLeft -= 100
          });
        }
      });

      buttonNext.addEventListener('click', () => {
        tabScrollContainer.scroll({
          behavior: "smooth",
          left: tabScrollContainer.scrollLeft += 100
        });
      });

      buttonPrev.addEventListener('click', () => {
        tabScrollContainer.scroll({
          behavior: "smooth",
          left: tabScrollContainer.scrollLeft -= 100
        });
      });

    }

    if (!hasRightSidebar) {
      try {
        //fader slideshow
        (function () {
          let targetNav = document.querySelectorAll('.tabs__nav--super_tabs.js-tabs__tns > .js-tabs__tabs-container');
          let tabNav = [];
          let index;

          targetNav.forEach(function (targ, index) {

            tabNav[index] = new tns({
              container: targ,
              autoplay: false,
              loop: false,
              autoWidth: true,
              // autoWidth: false,
              // nav: false,
              controlsText: ['<span class = "fas fa-caret-left"></span><span class = "sr-only">Next</span>', '<span class = "fas fa-caret-right"></span><span class = "sr-only">Previous</span>'],
              items: 1,
              nav: false,
              controls: true
            });
          });
        })();
      } catch (err) {
        console.log(err);
      }
    }


		try {
      //fader slideshow
      (function () {
        let targetNav = document.querySelectorAll('.tabs--simple .js-tabs__tns > .js-tabs__tabs-container');
        let tabNav = [];
        let index;

        targetNav.forEach(function (targ, index) {

          tabNav[index] = new tns({
            container: targ,
            autoplay: false,
            loop: false,
						autoWidth: true,
						gutter: 32,
						nav: false,
            controlsText: ['<span class = "fas fa-caret-left"></span><span class = "sr-only">Next</span>', '<span class = "fas fa-caret-right"></span><span class = "sr-only">Previous</span>'],
            items: 1,
          });
        });
			})();
		} catch (err) {
			console.warn(err);
		}

		try {
      (function () {

        const parsedUrl = new URL(window.location.href);
        let topTabSelection, bottomTabSelection, scrollIntoView;

        if (parsedUrl.search !== '') {
          topTabSelection = parsedUrl.searchParams.get('toptab');
          bottomTabSelection = parsedUrl.searchParams.get('contenttab');
          scrollIntoView = true;
        }

        const superTabsElement = document.getElementById('super_tabs');
        if (!superTabsElement) {
          return false;
        }

        // super tabs
        /** @param {JsTabs} superTabs **/
        const superTabs = new JsTabs({
          elm: '#super_tabs',
          shouldScrollTabIntoView: false,
        });
        superTabs.init();

        /** @param {HTMLElement} superTabsElem **/
        const superTabsElem = superTabs.navElm;

        if (superTabsElem) {
          /** @param {NodeList} super_tabs_tabs **/
          let super_tabs_tabs = superTabsElem.querySelectorAll('.js-tabs__tab');
          if (super_tabs_tabs.length) {
            let first_super_tab = super_tabs_tabs[0];
            if (!first_super_tab.classList.contains('active')) {
              first_super_tab.click();
            }
          }
          Array.from(super_tabs_tabs).forEach((tab, index) => {
            tab.addEventListener('click', event => {
              event.preventDefault();
              let newURLParams = addTabs();
              window.history.replaceState("object or string", "Title", newURLParams );
              function addTabs() {
                let tabsURL = window.location.pathname + '?toptab=' + tab.dataset.id,
                    subTabs = document.querySelector(`div#tab_${index} div.my-js-tabs__sub_tabs`);
                if (subTabs) {
                  let contentTab = subTabs.querySelector('li.active');
                  tabsURL = window.location.pathname + '?toptab=' + tab.dataset.id + '&contenttab=' + contentTab.dataset.id;
                }
                return tabsURL;
              }
            });
            if (topTabSelection) {
              if (tab.getAttribute('data-id') === topTabSelection) {
                tab.click();
              }
            }
          });
        }

        // subtabs
        const subTabs = document.querySelectorAll('.my-js-tabs__sub_tabs');
        subTabs.forEach(function (subTab, index) {
          let idName = "my-js-tabs__sub_tabs" + index;
          subTab.setAttribute("id", idName);

          const innerTabs = new JsTabs({
            elm: '#' + idName,
            shouldScrollTabIntoView: false,
          });
          innerTabs.init();

          const innerTabsElm = innerTabs.navElm;
          if (innerTabsElm) {
            let inner_tabs_tabs = innerTabsElm.querySelectorAll('.js-tabs__tab');

            /**
             * Check for existence of query param, otherwise see if we have a tab
             * to activate by default
             */
            if (inner_tabs_tabs.length) {
              Array.from(inner_tabs_tabs).forEach(innerTab => {
                innerTab.addEventListener('click', event => {
                  event.preventDefault();
                  let newURLParams = addInnerTabs();
                  window.history.replaceState("object or string", "Title", newURLParams );
                  function addInnerTabs() {
                    let topNav = document.querySelector('.tabs__nav--super_tabs ul'),
                        firstTopTab = topNav.firstElementChild,
                        topTabParam= window.location.search.split("&")[0],
                        tabsURL = window.location.pathname + '?toptab=' + firstTopTab.dataset.id + '&contenttab=' + innerTab.dataset.id;
                    if (topTabParam && topTabParam.startsWith('?toptab')) {
                      tabsURL = window.location.pathname + topTabParam + '&contenttab=' + innerTab.dataset.id;
                    }
                    return tabsURL;
                  }
                });
                if (bottomTabSelection) {
                  if (innerTab.getAttribute('data-id') === bottomTabSelection) {
                    innerTab.click();
                  }
                } else {
                  /**
                   * In case we have one or more tabs unpublished, the first tab may no longer
                   * be active. If so, find the first one and activate it
                   */
                  let first_tab = inner_tabs_tabs[0];
                  if (!first_tab.classList.contains('active')) {
                    first_tab.click();
                  }
                }
              });
            }
          }

        });
        if (scrollIntoView) {
          /** @param {DOMRect} superTabsRect **/
          const superTabsRect = superTabsElem.getBoundingClientRect();
          const expFactor = 0.98;
          if (superTabsRect instanceof DOMRect) {
            window.scrollTo(0, ((superTabsRect.y - superTabsRect.height) * expFactor));
          }
        }
      })();
		} catch (err) {
			console.warn(err);
		}

		try {
      (function () {

        const simpleTabs = document.querySelectorAll('.tabs--simple');
        const simpleTabsNavElms = [];

        simpleTabs.forEach(function (simpleTab, index) {
          let idName = "tabs--simple" + index;
          simpleTab.setAttribute("id", idName);

          const simpleTabsJS = new JsTabs({
            elm: '#' + idName,
            shouldScrollTabIntoView: false,
          })
          simpleTabsJS.init();
          simpleTabsNavElms.push(simpleTabsJS.navElm);
        });

        Array.from(simpleTabsNavElms).forEach(simpleNavElm => {
          let first_simple_tabs = simpleNavElm.querySelectorAll('.js-tabs__tab');
          if (first_simple_tabs.length) {
            let
              tabs_array = Array.from(first_simple_tabs),
              visible_tabs = tabs_array.filter(tab => (!tab.classList.contains('d-none'))),
              first_visible_tab = visible_tabs[0];

            if (first_visible_tab) {
              first_visible_tab.click();
            }
          }

        });
      })();
    } catch (err) {
			console.warn(err);
		}
  });
})();
